module.exports = __webpack_public_path__ + "static/media/inf_96og97.6305b213.mp3";